/* eslint-disable max-classes-per-file */
/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsEvent } from '@shure/shared/models';

import { CdmAnalyticsEvents } from './cdm-analytics-events.enum';
import { AnalyticsCommonDeviceInfo } from './common.model';

/**
 * Event to measure how a user interacts with the FW Update dialog,
 * such as where it is normally launched from and how many devices are selected at the time when the dialog is launched.
 */
export class FirmwareUpdateDialogLaunchedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.FirmwareUpdateDialogLaunched;
	public readonly properties: {
		location: FirmwareUpdateLocation;
		device_count: number;
	};

	constructor(location: FirmwareUpdateLocation, deviceCount: number) {
		this.properties = {
			location: location,
			device_count: deviceCount
		};
	}
}

/**
 * Event to measure how often a user closes the FW Update dialog w/out updating firmware
 */
export class FirmwareUpdateDialogCancelledEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.FirmwareUpdateDialogCancelled;
	public readonly properties = {};
}

/**
 * Event to measure how often a user initiates a firmware update, immediate or scheduled, and the accompanying device information.
 */
export class FirmwareUpdateSubmittedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.FirmwareUpdateSubmitted;
	public readonly properties: {
		location: FirmwareUpdateLocation;
		event_sub_type: FirmwareUpdateType;
		devices: FirmwareUpdateDeviceInfo[];
	};

	constructor(
		location: FirmwareUpdateLocation,
		eventSubType: FirmwareUpdateType,
		devices: FirmwareUpdateDeviceInfo[]
	) {
		this.properties = {
			location: location,
			event_sub_type: eventSubType,
			devices: devices
		};
	}
}

/**
 * Event to measure how often devices are removed from a scheduled firmware update, and the accompanying device information.
 */
export class FirmwareUpdateRemovedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.FirmwareUpdateRemoved;
	public readonly properties: {
		location: FirmwareUpdateLocation;
		device: AnalyticsCommonDeviceInfo;
	};

	constructor(location: FirmwareUpdateLocation, device: AnalyticsCommonDeviceInfo) {
		this.properties = {
			location: location,
			device: device
		};
	}
}

export enum FirmwareUpdateLocation {
	PropertiesPanel = 'properties_panel',
	InventoryView = 'inventory_view',
	InventoryTable = 'inventory_table'
}

export enum FirmwareUpdateType {
	Immediate = 'immediate',
	Scheduled = 'scheduled'
}

export interface FirmwareUpdateDeviceInfo
	extends Pick<AnalyticsCommonDeviceInfo, 'model' | 'mac' | 'serial' | 'hardware_id'> {
	old_firmware_package_version: string;
	new_firmware_package_version: string;
	new_firmware_package_key: string;
	hosted: boolean;
}
